import React from 'react'
import { Switch } from 'react-router-dom'
import { history } from '../../_helpers/history'
import { withRouter, useRouteMatch } from 'react-router'

import ListMessages from './List'
import MessageSearch from './Search'
import MessageStream from './Stream'
import ContainerFluid from '../../_layouts/ContainerFluid/'
import AuthorizedRoute from '../../_helpers/authorized.route'

function RedirectOldRoute(props) {
  const conversationId = props.match.params.conversationId
  history.push(`/messages/${conversationId}/view`)
  return null
}

const Messages = () => {
  let { path } = useRouteMatch()

  return (
    <Switch>
      <AuthorizedRoute path="/patients/:patientId/messages/:conversationId" component={RedirectOldRoute} />
      <AuthorizedRoute path={`${path}/:patientId/conversation/:conversationId`} component={RedirectOldRoute} />
      <AuthorizedRoute path={`${path}/:id?/view`} layout={ContainerFluid} component={MessageStream} />
      <AuthorizedRoute path={`${path}/send`} layout={ContainerFluid} component={MessageSearch} />
      <AuthorizedRoute path={`${path}`} component={ListMessages} />
    </Switch>
  )
}


export default withRouter(Messages)